module.exports = __webpack_public_path__ + "static/media/logo_wejdi1.e52a5fed.png";